import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  titleText: () => i18n.t(i18nKeys.deliveryIssueTakeover_title),
  descriptionText: () => i18n.t(i18nKeys.deliveryIssueTakeover_description),
  descriptionText2: () => i18n.t(i18nKeys.deliveryIssueTakeover_description2),
  descriptionText3: () => i18n.t(i18nKeys.deliveryIssueTakeover_description3),
  buttonText: () => i18n.t(i18nKeys.deliveryIssueTakeover_button),
  learnMore: () => i18n.t(i18nKeys.deliveryIssueTakeover_link_learn_more),
  continue: () => i18n.t(i18nKeys.common__continue),
  extremelyLateTitle: () =>
    i18n.t(i18nKeys.deliveryIssueTakeoverExtremelyLate_title),
  extremelyLateDescription1: () =>
    i18n.t(i18nKeys.deliveryIssueTakeoverExtremelyLate_description1),
  extremelyLateDescription2: () =>
    i18n.t(i18nKeys.deliveryIssueTakeoverExtremelyLate_description2),
}
